var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.125 0H6.875C3.07804 0 0 3.07804 0 6.875V37.125C0 40.922 3.07804 44 6.875 44H37.125C40.922 44 44 40.922 44 37.125V6.875C44 3.07804 40.922 0 37.125 0Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2 22.0002C35.2 28.3791 29.2901 33.5502 22 33.5502C19.5388 33.5502 17.2349 32.9608 15.2627 31.9345L8.79999 33.5502L11.0082 28.3977C9.61311 26.5662 8.79999 24.3663 8.79999 22.0002C8.79999 15.6213 14.7098 10.4502 22 10.4502C29.2901 10.4502 35.2 15.6213 35.2 22.0002ZM17.05 20.3502H13.75V23.6502H17.05V20.3502ZM30.25 20.3502H26.95V23.6502H30.25V20.3502ZM20.35 20.3502H23.65V23.6502H20.35V20.3502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.33d7c46a3adfc31742d68f9a95844409.svg";
export { ForwardRef as ReactComponent };